import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme, useMediaQuery, Grid, List, ListItem } from '@mui/material';

// Custom Components
import PublicPage from '@/ui/PublicPage/PublicPage';

function SafetyAdvicePage() {
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <PublicPage overrideBgImage>
      <Box width='100%'>
        <Container maxWidth='xxl' style={{ padding: 0 }}>
          <Grid container p={isMobile ? 3 : 10}>
            <Grid size={{ xs: 12, md: 5, lg: 3 }}>
              <Typography
                color='primary'
                variant='h4'
                component='h1'
                sx={{
                  position: !isMobile ? 'fixed' : 'unset',
                }}
              >
                {t('public.headings.safety_advice')}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 7, lg: 5 }} container mt={isMobile ? 2 : 0} columnGap='50px'>
              <Box textAlign='left' mt={isMobile ? 2 : 0}>
                <Box>
                  <Typography variant="body1" fontWeight={600} color="primary">
                    {t('public.headings.safety_advice_visitors')}
                  </Typography>
                  <List sx={{ listStyleType: 'disc', padding: 0 }}>
                    {t('public.safety_advice_visitors_text')
                      .split('|')
                      .map((x, i) => <ListItem
                            key={'first-section-items-' + i}
                            sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                          >
                            <Typography color="black">{x}</Typography>
                          </ListItem>
                       )}
                  </List>
                </Box>

                <Box mt={3}>
                  <Typography variant="body1" fontWeight={600} color="primary">
                    {t('public.headings.safety_advice_accident')}
                  </Typography>
                  <List sx={{ listStyleType: 'disc', padding: 0 }}>
                    {t('public.safety_advice_accident_text')
                      .split('|')
                      .map((x, i) => <ListItem
                            key={'second-section-items-' + i}
                            sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                          >
                            <Typography color="black">{x}</Typography>
                          </ListItem>
                        )}
                  </List>
                </Box>

                <Box mt={3}>
                  <Typography variant="body1" fontWeight={600} color="primary">
                    {t('public.headings.safety_advice_accident_notice')}
                  </Typography>
                  <List sx={{ listStyleType: 'disc', padding: 0 }}>
                    {t('public.safety_advice_accident_notice_text')
                      .split('|')
                      .map((x, i) => <ListItem
                            key={'third-section-items-' + i}
                            sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                          >
                            <Typography color="black">{x}</Typography>
                          </ListItem>
                        )}
                  </List>
                </Box>

                <Box mt={3}>
                  <Typography variant="body1" fontWeight={600} color="primary">
                    {t('public.headings.safety_advice_accident_info')}
                  </Typography>
                  <List sx={{ listStyleType: 'disc', padding: 0 }}>
                    {t('public.safety_advice_accident_info_text')
                      .split('|')
                      .map((x, i) => <ListItem
                            key={'forth-section-items-' + i}
                            sx={{ display: 'list-item', padding: 0, color: 'primary.main', fontSize: '0.875rem' }}
                          >
                            <Typography color="black">{x}</Typography>
                          </ListItem>
                        )}
                  </List>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </PublicPage>
  );
}

export default SafetyAdvicePage;
